module.exports = __webpack_public_path__ + "img/okr-team.28814475.png";